import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/api/apiSingleton';
import { withDefaultErrorHandling } from '@/store/utils';
import { setUser } from '../user/userSlice';

export const createPlaidLinkToken = createAsyncThunk(
  'plaid/createPlaidLinkToken',
  withDefaultErrorHandling(async (_: undefined) => {
    const data = await api.plaid.createPlaidLinkToken();

    return {
      linkToken: data.data.linkToken,
      userId: data.data.userId,
    };
  }),
);

export const updatePlaidLinkToken = createAsyncThunk(
  'plaid/updatePlaidLinkToken',
  withDefaultErrorHandling(async (id: number) => {
    const data = await api.plaid.updatePlaidLinkToken({
      id,
    });

    return data.data;
  }),
);

export const exchangePublicToken = createAsyncThunk(
  'plaid/exchangePublicToken',
  withDefaultErrorHandling(async (payload: { publicToken: string; userId: number }, thunkApi) => {
    await api.plaid.exchangePublicToken({ publicToken: payload.publicToken });

    const user = await api.user.show();

    thunkApi.dispatch(setUser(user.data));
  }),
);

export const getConnections = createAsyncThunk(
  'plaid/getConnections',
  withDefaultErrorHandling(async (_: undefined) => {
    const data = await api.plaid.getConnections();

    return data.data;
  }),
);
